const bulkLabelDataPrefix = 'bulk-label';
export const BULK_LABEL_DATA_ID = {
  add: `${bulkLabelDataPrefix}-add`,
  dropDown: `${bulkLabelDataPrefix}-dropdown`,
  checkBox: `${bulkLabelDataPrefix}-checkbox`,
  bulkCheckBoxText: `${bulkLabelDataPrefix}-bulk-checkbox-text`,
};
